/* eslint-disable import/prefer-default-export */
import { useProduct } from '@modules/product';
import { useFeatureEligibility } from '@modules/featureControl';
import { useProductType } from '@composables/useProductType';
import { GIFT_CARD_TYPE } from '../constants';

/**
 * * Gift Card Type Composable
 *
 * @description
 * Determines the type of gift card
 *
 * Possible values:
 * - 'basic' - Basic gift card
 * - 'egiftcard' - E-gift card
 * - 'consolidated' - Consolidated gift card
 */
export const useGiftCardType = () => {
  const { productId } = useProduct();
  const { isConsolidatedMaster } = useProductType({ productId });
  const { isEGiftCard } = useFeatureEligibility();

  if (isConsolidatedMaster) {
    return GIFT_CARD_TYPE.CONSOLIDATED_MASTER;
  }

  if (isEGiftCard) {
    return GIFT_CARD_TYPE.E_GIFT_CARD;
  }

  return GIFT_CARD_TYPE.BASIC;
};
